import React from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Select from "components/Select";
import FormField from "../account/components/FormField";

function InputFilters({ handleUserIDChange, handleSearch }) {
  const onKeyDown = (e) => {
    if (e.key === "Enter") handleSearch();
  };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex">
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          variant="gradient"
          bgColor="primary"
          color="white"
          shadow="md"
          borderRadius="xl"
          ml={3}
          mt={-2}
        >
          <Icon fontSize="medium" color="inherit">
            search
          </Icon>
        </MDBox>
        <MDBox>
          <MDTypography variant="h6" sx={{ mt: 2, mb: 1, ml: 2 }}>
            Advanced Search
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox p={2} display="flex">
        <Grid container alignItems="center">
          <Grid item xs={12} sm={4}>
            <MDBox px={2}>
              <FormField
                type="text"
                label="Enter Email"
                name="userID"
                onChange={handleUserIDChange}
                onKeyDown={onKeyDown}
              />
            </MDBox>
          </Grid>
          <Grid item xs="auto">
            <MDBox px={1}>
              <IconButton
                onClick={handleSearch}
                sx={{
                  background: "linear-gradient(195deg, #EC407A, #D81B60)",
                  color: "#fff",
                  borderRadius: "8px",
                  padding: "8px 16px",
                  "&:hover": { background: "linear-gradient(195deg, #D81B60, #C2185B)" },
                }}
              >
                <Icon>search</Icon>
              </IconButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default InputFilters;
